import React from 'react';

// V0.9 LOT 1 — Icônes SF Symbols-style monochromes line-art
// Hairline 1.75px stroke, currentColor (s'adapte au thème),
// pas de glyphe "off" : l'overlay barre rouge est ajouté par le parent.

type IconProps = {
  size?: number;
  active?: boolean;
  danger?: boolean;
};

const Svg: React.FC<React.PropsWithChildren<IconProps>> = ({ size = 22, active, danger, children }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={active ? 2 : 1.75}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    style={{ color: danger ? '#fca5a5' : 'currentColor', display: 'block' }}
  >
    {children}
  </svg>
);

export const MicIcon: React.FC<IconProps> = (p) => (
  <Svg {...p}>
    <rect x="9" y="3" width="6" height="12" rx="3" />
    <path d="M5 11v1a7 7 0 0 0 14 0v-1" />
    <path d="M12 19v3" />
    <path d="M8 22h8" />
  </Svg>
);

export const CameraIcon: React.FC<IconProps> = (p) => (
  <Svg {...p}>
    <rect x="2" y="6" width="14" height="12" rx="2.5" />
    <path d="M16 10l5-3v10l-5-3z" />
  </Svg>
);

export const ScreenShareIcon: React.FC<IconProps> = (p) => (
  <Svg {...p}>
    <rect x="2" y="4" width="20" height="13" rx="2" />
    <path d="M9 21h6" />
    <path d="M12 17v4" />
    <path d="M9 11l3-3 3 3" />
    <path d="M12 8v6" />
  </Svg>
);

export const ChatIcon: React.FC<IconProps> = (p) => (
  <Svg {...p}>
    <path d="M21 12a8 8 0 0 1-12 6.9L4 21l2.1-5A8 8 0 1 1 21 12z" />
  </Svg>
);

export const ParticipantsIcon: React.FC<IconProps> = (p) => (
  <Svg {...p}>
    <circle cx="9" cy="8" r="3.5" />
    <path d="M2 21v-1.5A4.5 4.5 0 0 1 6.5 15h5A4.5 4.5 0 0 1 16 19.5V21" />
    <circle cx="17.5" cy="9.5" r="2.5" />
    <path d="M16.5 14.2a4 4 0 0 1 5.5 3.7V19" />
  </Svg>
);

export const NestorIcon: React.FC<IconProps> = (p) => (
  <Svg {...p}>
    <rect x="4" y="6" width="16" height="13" rx="3" />
    <path d="M12 3v3" />
    <circle cx="9" cy="12" r="1" fill="currentColor" stroke="none" />
    <circle cx="15" cy="12" r="1" fill="currentColor" stroke="none" />
    <path d="M9 16h6" />
    <path d="M2 13v2" />
    <path d="M22 13v2" />
  </Svg>
);

export const GridIcon: React.FC<IconProps> = (p) => (
  <Svg {...p}>
    <rect x="3" y="3" width="7.5" height="7.5" rx="1.5" />
    <rect x="13.5" y="3" width="7.5" height="7.5" rx="1.5" />
    <rect x="3" y="13.5" width="7.5" height="7.5" rx="1.5" />
    <rect x="13.5" y="13.5" width="7.5" height="7.5" rx="1.5" />
  </Svg>
);

export const ExitIcon: React.FC<IconProps> = (p) => (
  <Svg {...p}>
    <path d="M15 4h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3" />
    <path d="M10 17l5-5-5-5" />
    <path d="M15 12H3" />
  </Svg>
);

export const SunIcon: React.FC<IconProps> = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2" />
    <path d="M12 20v2" />
    <path d="M2 12h2" />
    <path d="M20 12h2" />
    <path d="M4.9 4.9l1.5 1.5" />
    <path d="M17.6 17.6l1.5 1.5" />
    <path d="M4.9 19.1l1.5-1.5" />
    <path d="M17.6 6.4l1.5-1.5" />
  </Svg>
);

export const TranslateIcon: React.FC<IconProps> = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18" />
    <path d="M12 3a14 14 0 0 1 0 18" />
    <path d="M12 3a14 14 0 0 0 0 18" />
  </Svg>
);

export const MoonIcon: React.FC<IconProps> = (p) => (
  <Svg {...p}>
    <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
  </Svg>
);

// Overlay barre rouge diagonale (top-right → bottom-left)
// utilisée par le parent quand un toggle est en état OFF.
export const OffBar: React.FC<{ size?: number }> = ({ size = 22 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      pointerEvents: 'none',
      filter: 'drop-shadow(0 0 1px rgba(0,0,0,0.6))',
    }}
  >
    <line
      x1="20"
      y1="4"
      x2="4"
      y2="20"
      stroke="#ef4444"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);
